'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { Page as PageWrapper } from 'src/components/Organisms/Page';
import { OverviewPage as OverviewPageContent } from 'src/components/Pages/Overview';
export default function OverviewPage() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PageWrapper><OverviewPageContent /></PageWrapper>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}